<template>
    <div class="app flex-row align-items-center">
        <form @submit.prevent="attemptLogin" class="w-100">
            <div class="container">
                <b-row class="justify-content-center">
                    <b-col md="8">
                        <b-card-group>
                            <b-card no-body class="p-4">
                                <b-card-body>
                                    <h1 class="text-center">
                                        <img src="images\logo.jpg" class="w-50" alt="eredit� facile" />
                                    </h1>
                                    <p class="text-muted">Accedi con il tuo account</p>
                                    <b-input-group class="mb-3">
                                        <div class="input-group-prepend"><span class="input-group-text"><i class="icon-user"></i></span></div>
                                        <input type="text" class="form-control d-block" placeholder="Username" v-model="user.username" name="username" v-validate="'required'" :class="errors.has('username')?'form-control--danger':''" />

                                    </b-input-group>

                                    <b-input-group class="mb-4">
                                        <div class="input-group-prepend"><span class="input-group-text"><i class="icon-lock"></i></span></div>
                                        <input type="password" class="form-control" placeholder="Password" v-model="user.password" name="password" v-validate="'required'" :class="errors.has('password')?'form-control--danger':''">
                                    </b-input-group>
                                    <b-row v-if="errormessage!=''">
                                        <b-col cols="12" class="text-center alert alert-danger">
                                            {{errormessage}}
                                        </b-col>

                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" class="text-center">
                                            <button type="submit" class="btn btn-primary btn-lg btn-block [ mt-4 ]">Accedi</button>
                                        </b-col>

                                    </b-row>
                                </b-card-body>
                            </b-card>

                        </b-card-group>
                    </b-col>
                </b-row>
            </div>
        </form>
    </div>
        
</template>

<script>
import axios from 'axios';

    export default {
        name: 'ViewLogin',
        data() {
            return {
                user: {
                    username: '',
                    password: ''
                },
                errormessage: ''
            };
        },
        beforeMount() {

            this.$store.commit('clearAuth');
        },
        methods: {
            attemptLogin() {
                var me = this;
                me.$store.commit('clearAuth');

                this.$validator.validateAll().then(isValid => {
                    me.error = "";
                    if (isValid) {
                        this.$store
                            .dispatch('login', {
                                username: me.user.username,
                                password: me.user.password
                            }).then(response => {
                                console.log(response);
                                if (response.status == 200) {

                                    if (response.data.token != "") {
                                        var theToken = response.data.token;
                                        this.$store.commit('authUser', { user: response.data });
                                        this.$router.push({ name: 'route-index' });
                                    }
                                    else {
                                        me.errormessage = 'Attenzione, non riconosco le credenziali utilizzate';
                                    }

                                }
                            })
                            .catch(error => {
                                console.log(error);
                                me.errormessage = 'Attenzione, non riconosco le credenziali utilizzate';
                            });


                    }
                });
            }
        }
    };
</script>
